var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorymakers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96739 9.66666C11.2541 9.66666 12.3007 8.61999 12.3007 7.33333C12.3007 6.04666 11.2541 5 9.96739 5C8.68073 5 7.63407 6.04666 7.63407 7.33333C7.63407 8.61999 8.68073 9.66666 9.96739 9.66666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.634 11C15.5533 11 16.3007 10.252 16.3007 9.33331C16.3007 8.41464 15.5533 7.66664 14.634 7.66664C13.7147 7.66664 12.9674 8.41464 12.9674 9.33331C12.9674 10.252 13.7147 11 14.634 11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30128 11C6.21995 11 6.96795 10.252 6.96795 9.33331C6.96795 8.41464 6.21995 7.66664 5.30128 7.66664C4.38262 7.66664 3.63462 8.41464 3.63462 9.33331C3.63462 10.252 4.38262 11 5.30128 11Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96767 10.3333C7.57834 10.3333 5.63434 12.2773 5.63434 14.6666C5.63434 14.8506 5.78368 14.9999 5.96768 14.9999H13.9677C14.1517 14.9999 14.301 14.8506 14.301 14.6666C14.301 12.2773 12.357 10.3333 9.96767 10.3333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63411 11.7387C5.44637 11.6954 5.25556 11.6667 5.06168 11.6667C3.53889 11.6667 2.30078 13.0127 2.30078 14.6667C2.30078 14.8507 2.4376 15.0001 2.60755 15.0001H4.81136C4.777 14.8954 4.75491 14.7841 4.75491 14.6667C4.75491 13.5727 5.08377 12.5627 5.63411 11.7387Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8726 11.6667C14.6787 11.6667 14.4879 11.6954 14.3002 11.7387C14.8505 12.5627 15.1793 13.5727 15.1793 14.6667C15.1793 14.7841 15.1573 14.8954 15.1229 15.0001H17.3267C17.496 15.0001 17.6335 14.8507 17.6335 14.6667C17.6335 13.0127 16.3948 11.6667 14.8726 11.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorymakers);
export default __webpack_public_path__ + "static/media/storymakers.9d9d494738de2c6bd7e451729fabe1ce.svg";
export { ForwardRef as ReactComponent };